import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import {window} from 'ssr-window';

let cancelStripeResponse = false;
let stripeResponseTimeout;

const defaultErrorMsg = 'There was an issue processing your request.  Please try again and/or contact customer support.';

const StripeUtils = {
    init(key) {
        if (isUndefined(window.Stripe)) {
            // Don't use stripe if we're not connected to internet.
            return;
        }

        window.StripeV3 = window.Stripe(key);
        window.StripeElements = window.StripeV3.elements();
    },

    createToken({isAdmin, onSuccess, onError = null}) {
        if (isEmpty(window.StripeV3) || isEmpty(window.SHStripeCardElement)) {
            if (onError) {
                onError(defaultErrorMsg);
            }

            return;
        }

        window.StripeV3.createToken(window.SHStripeCardElement)
            .then(result => {
                if (cancelStripeResponse) {
                    cancelStripeResponse = false;

                    return;
                }

                if (result.error) {
                    clearTimeout(stripeResponseTimeout);

                    if (onError) {
                        onError(result.error.message);
                    }
                } else {
                    clearTimeout(stripeResponseTimeout);
                    onSuccess(result.token.id);
                }
            });

        stripeResponseTimeout = setTimeout(() => {
            cancelStripeResponse = true;

            const msg = (isAdmin)
                ? 'The Stripe API timed out. Please refresh the page and try again.'
                : 'An error occurred while reserving your parking spot. Please refresh the page and try again.';

            if (onError) {
                onError(msg);
            }
        }, 15000);
    }
};

export default StripeUtils;
